import "./Doctors.css";
import React, { useContext } from "react";
import { Link } from "react-router-dom";
import doctorContext from "../../../context/doctors/doctorscontext";

function Doctors() {
  const { docInfo } = useContext(doctorContext);

  const doctorsList = [
    {
      id: 1,
      name: "Dr. Nishita Rao",
      role: "Obstetrician & Gynaecologist",
      quals: "MBBS, MS — Obstetrics & Gynaecology",
      exp: "18 years of experience",
      bio: "Dr. Nishita Rao specialises in obstetrics and gynaecology, focusing on comprehensive care for women throughout their pregnancy journey. She is known for a patient-centric approach and a 90% success rate in normal deliveries, and addresses a wide range of women's health concerns from puberty to menopause.",
      img: "/img/doctors/dr-nishita-rao-lakshmi-maternity.webp"
    },
    {
      id: 2,
      name: "Dr. Mahesh B Rao",
      role: "Paediatrician",
      quals: "Child Specialist, expertise in Paediatric Medicine",
      exp: "21 years of experience",
      bio: "Dr. Mahesh is a highly skilled paediatrician dedicated to compassionate care for children. He oversees our child care services and ensures every child receives the best possible care for their health and development, from newborn screening through adolescent health.",
      img: "/img/doctors/dr-mahesh-rao.webp"
    }
  ];

  return (
    <section className="band tint" id="doctors">
      <div className="wrap">
        <p className="eyebrow">Our doctors</p>
        <h2 className="h-sec">Meet the team.</h2>
        <p className="lede" style={{ marginTop: "20px" }}>
          Dr. Nishita Rao and Dr. Mahesh B Rao, the co-founders of our institution, bring their expertise and passion to the care of our patients.
        </p>

        <div className="docs">
          {doctorsList.map((doc) => (
            <article className="doc" key={doc.id}>
              <div className="portrait">
                <img
                  src={doc.img}
                  alt={doc.name}
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = "/img/uplaods/General-services.webp";
                  }}
                />
              </div>
              <div>
                <h3>{doc.name}</h3>
                <p className="role">{doc.role}</p>
                <p className="quals">
                  {doc.quals}
                  <br />
                  <em>{doc.exp}</em>
                </p>
                <p className="bio">{doc.bio}</p>
              </div>
            </article>
          ))}
        </div>

        <p className="body-copy" style={{ marginTop: "40px", maxWidth: "78ch" }}>
          Together, Dr. Mahesh and Dr. Nishita Rao work with a team of experienced healthcare professionals to offer personalised, evidence-based care. Their leadership has shaped the values and philosophy of Lakshmi Maternity &amp; Surgical Centre. Please note that the availability of specific doctors may vary &mdash; it is always advisable to contact the hospital directly for the most up-to-date information.
        </p>

        <div style={{ marginTop: '24px' }}>
          <Link to="/doctors" className="btn-ghost">
            View doctor profiles &amp; normal delivery approach &rarr;
          </Link>
        </div>
      </div>
    </section>
  );
}

export default Doctors;